module.exports = __webpack_public_path__ + "static/media/9H.a6b14596.svg";